import Vue from 'vue';
import Notificaciones from './Notificaciones.vue';

const NotificadorConstructor = Vue.extend(Notificaciones);
const instanciasPorPosicion = {};

function obtenerInstancia(position) {
  if (!instanciasPorPosicion[position]) {
    const instancia = new NotificadorConstructor({
      propsData: { position }
    });
    instancia.$mount();
    document.body.appendChild(instancia.$el);
    instanciasPorPosicion[position] = instancia;
  }
  return instanciasPorPosicion[position];
}

const NotificadorPlugin = {
  install(Vue, options = {}) {
    const estiloGlobal = options.estiloGlobal || {};

    Vue.prototype.$notificar = (
        mensaje,
        opciones = {}
        ) => {
        const {
            tipo = 'info',
            time = 3000,
            position = 'bottom-left',
            customStyle = {},
            customContainerStyle = {}
        } = opciones;

        const instancia = obtenerInstancia(position);
        const estiloGlobalTipo = estiloGlobal[tipo] || {};

        const estiloFinal = {
            ...estiloGlobalTipo,
            ...customStyle
        };

        const marcaColor = estiloFinal.marcaColor;
        if (marcaColor) {
            if (position === 'top-center') {
                estiloFinal.borderTop = `5px solid ${marcaColor}`;
            } else if (position === 'bottom-center') {
                estiloFinal.borderBottom = `5px solid ${marcaColor}`;
            } else if (position.endsWith('left')) {
                estiloFinal.borderLeft = `5px solid ${marcaColor}`;
            } else if (position.endsWith('right')) {
                estiloFinal.borderRight = `5px solid ${marcaColor}`;
            }
            }

        instancia.mostrar(mensaje, tipo, time, estiloFinal, customContainerStyle);
    };
  }
};

export default NotificadorPlugin;
